import { render, staticRenderFns } from "./Setphone.vue?vue&type=template&id=1fd7090e&scoped=true"
import script from "./Setphone.vue?vue&type=script&lang=js"
export * from "./Setphone.vue?vue&type=script&lang=js"
import style0 from "./Setphone.vue?vue&type=style&index=0&id=1fd7090e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd7090e",
  null
  
)

export default component.exports